import React, { useContext } from "react";
import { injectIntl } from "react-intl";
import Column from "@amzn/meridian/column";
import ScanWithCodeView from "../../scanBarcode/ScanWithCodeView";
import { getAssociateStatusByBarcodeScan } from "../action/scanBarcodeAction";
import { ScanBarcodeContext } from "../context/ScanBarcodeContext";
import { COMMON_ACTIONS } from "../constants/ActionType";
import LoaderView from "../../loader/Loader";
import { getAliasByEmail } from "../../util/Util";
import Row from "@amzn/meridian/row";

const ScanBarcodeView = (props) => {
  const { ScanBarcodeViewModel, ScanBarcodeViewDispatch } =
    useContext(ScanBarcodeContext);
  const onBarcodeScan = (input) => {
    ScanBarcodeViewDispatch({ type: COMMON_ACTIONS.LOADING });
    getAssociateStatusByBarcodeScan(ScanBarcodeViewDispatch, input.trim()).then(
      (username) => {
        if (!username) {
          props.onScanResponse(true, "");
        } else {
          const barcode_alias = getAliasByEmail(username);
          props.onScanResponse(false, barcode_alias);
        }
      },
    );
  };

  const renderBarcodeScanComponent = () => {
    return (
      <Column spacingInset={"400 none none 450"} height="70%">
        <ScanWithCodeView
          image={props.image}
          onSubmit={onBarcodeScan}
          focusLock={true}
        />
      </Column>
    );
  };

  return (
    <div>
      {ScanBarcodeViewModel.isLoading ? (
        <Row spacingInset={"500 none none 600"}>
          <LoaderView />
        </Row>
      ) : (
        renderBarcodeScanComponent()
      )}
    </div>
  );
};

export default injectIntl(ScanBarcodeView);



// WEBPACK FOOTER //
// ./src/components/scanBarcode/views/ScanBarcodeView.js